// Import model
import { DataviewSectionLineResponse } from '../models/DataviewSectionLineResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterSectionLineRequest } from '../models/FilterSectionLineRequest';
import { SectionLine } from '../models/SectionLine';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterSectionLineRequestSerializer } from './FilterSectionLineRequestSerializer';
import { SectionLineSerializer } from './SectionLineSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewSectionLineResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewSectionLineResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewSectionLineResponse instance
   */
  static deserialize(json: string): DataviewSectionLineResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewSectionLineResponse instance
   */
  static fromObject(obj: any): DataviewSectionLineResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewSectionLineResponse');
    }


    const instance: DataviewSectionLineResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        SectionLineSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterSectionLineRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewSectionLineResponse instances
   */
  static deserializeArray(json: string): DataviewSectionLineResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewSectionLineResponse instance to a JSON string
   */
  static serialize(instance: DataviewSectionLineResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewSectionLineResponse instance to a plain object
   */
  static toObject(instance: DataviewSectionLineResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        SectionLineSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterSectionLineRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewSectionLineResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewSectionLineResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
